import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = {
  key: 1,
  class: "row"
}
const _hoisted_3 = { class: "col-md-8 mx-auto" }
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-5" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "row mt-4" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = {
  key: 0,
  class: "row mt-3"
}
const _hoisted_12 = {
  key: 2,
  class: "row"
}
const _hoisted_13 = { class: "col-md-8 mx-auto" }
const _hoisted_14 = { class: "mt-3" }
const _hoisted_15 = { class: "fw-bold" }
const _hoisted_16 = { class: "fw-bold" }
const _hoisted_17 = {
  href: "https://www.moneysavingexpert.com/savings/voluntary-national-insurance-contributions/",
  target: "_blank"
}
const _hoisted_18 = {
  key: 0,
  class: "row"
}
const _hoisted_19 = { class: "col" }
const _hoisted_20 = { class: "row mt-4" }
const _hoisted_21 = { class: "col" }
const _hoisted_22 = {
  key: 1,
  class: "row mt-3"
}
const _hoisted_23 = {
  key: 3,
  class: "row"
}
const _hoisted_24 = { class: "col-md-8 mx-auto" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-5" }
const _hoisted_27 = { class: "row mt-4" }
const _hoisted_28 = { class: "col" }
const _hoisted_29 = {
  key: 0,
  class: "row mt-3"
}
const _hoisted_30 = {
  key: 4,
  class: "row"
}
const _hoisted_31 = { class: "col-md-8 mx-auto" }
const _hoisted_32 = { class: "fw-bold" }
const _hoisted_33 = { class: "row mt-2" }
const _hoisted_34 = { class: "col" }
const _hoisted_35 = {
  key: 1,
  class: "row mt-3"
}
const _hoisted_36 = { class: "col" }
const _hoisted_37 = { class: "warn" }
const _hoisted_38 = {
  key: 5,
  class: "row"
}
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "col-md-8 mx-auto" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_43 = { class: "warn" }
const _hoisted_44 = {
  key: 2,
  class: "row mt-2"
}
const _hoisted_45 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_options_question = _resolveComponent("options-question")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[56] || (_cache[56] = _createElementVNode("header", { class: "text-center mb-4" }, [
      _createElementVNode("h2", { class: "skin-page-heading" }, "State Pension Help"),
      _createElementVNode("h4", { class: "col-sm-6 mx-auto" }, " Help with your State Pension in your Plan ")
    ], -1)),
    (_ctx.showOverSPA)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[17] || (_cache[17] = [
          _createElementVNode("div", { class: "col-md-8 mx-auto" }, [
            _createElementVNode("p", null, " You are over your State Pension Age. "),
            _createElementVNode("p", null, " Your State Pension will already be in payment and you will know what you are being paid. Just use the current annual figure in your plan. "),
            _createElementVNode("p", null, " This will increase at the maximum of 2.5%, inflation (CPI) and average earnings each April. We assume the future increase will be 2.5% a year, which is the most cautious, but will update for actual increases automatically when known. ")
          ], -1)
        ])))
      : _createCommentVNode("", true),
    (_ctx.showUnderSPAIntro)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[24] || (_cache[24] = _createElementVNode("p", null, " You are under State Pension Age. ", -1)),
            _createElementVNode("p", null, [
              _cache[18] || (_cache[18] = _createTextVNode(" We have currently estimated you will get a full flat rate revalued State Pension of ")),
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.estimatedStatePension), 1),
              _cache[19] || (_cache[19] = _createTextVNode(" from your State Pension Age. "))
            ]),
            _cache[25] || (_cache[25] = _createElementVNode("p", null, " However, as ever, things are a bit more complex than that. ", -1)),
            _cache[26] || (_cache[26] = _createElementVNode("p", null, [
              _createTextVNode(" Your actual State Pension depends on the level of National Insurance (NI) contributions you will have at State Pension Age. OK here is the good news, you can "),
              _createElementVNode("a", {
                href: "https://www.gov.uk/check-national-insurance-record",
                target: "_blank"
              }, "get an estimate of your NI contribution history to the current date"),
              _createTextVNode(". Once there, you need to set up a Government Gateway login if you don't have one, details of how to do that are on the page. ")
            ], -1)),
            _cache[27] || (_cache[27] = _createElementVNode("p", null, " Once you are set up and have logged in, click check National Insurance contribution and you will see ", -1)),
            _createElementVNode("ul", null, [
              _cache[20] || (_cache[20] = _createElementVNode("li", null, "X years of full contributions", -1)),
              _createElementVNode("li", null, " Y years to contribute before the " + _toDisplayString(_ctx.statePensionEntitlementDate), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[21] || (_cache[21] = _createElementVNode("span", { class: "me-2" }, "Enter the figure for X here:", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.yearsFullContribsModel) = $event)),
                  size: "3",
                  maxlength: "2",
                  onKeypress: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.checkNumeric && _ctx.checkNumeric(...args)))
                }, null, 544), [
                  [_vModelText, _ctx.yearsFullContribsModel]
                ])
              ])
            ]),
            _cache[28] || (_cache[28] = _createElementVNode("p", { class: "mt-3" }, " As shown you still have Y more years before your State Pension Age to gain more NI contributions. ", -1)),
            _cache[29] || (_cache[29] = _createElementVNode("p", null, " How many of those remaining Y years do you think you will be working (or claiming benefits of some kind, child, unemployment, carer benefits as examples)? ", -1)),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[22] || (_cache[22] = _createElementVNode("span", { class: "me-2" }, "Enter the number of those remaining years here:", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.yearsFutureContribsModel) = $event)),
                  size: "3",
                  maxlength: "2",
                  onKeypress: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.checkNumeric && _ctx.checkNumeric(...args)))
                }, null, 544), [
                  [_vModelText, _ctx.yearsFutureContribsModel]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onUnderSPAIntroNextClick && _ctx.onUnderSPAIntroNextClick(...args)))
                }, " Next ")
              ])
            ]),
            (_ctx.showUnderSPAError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[23] || (_cache[23] = [
                  _createElementVNode("div", { class: "col" }, [
                    _createElementVNode("span", { class: "warn" }, "Please enter the figures for contribution years.")
                  ], -1)
                ])))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showInitialEst)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("p", _hoisted_14, [
              _cache[30] || (_cache[30] = _createTextVNode(" You have told us by the time you reach State Pension Age you expect to have paid a total of ")),
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.totalContributionYears), 1),
              _cache[31] || (_cache[31] = _createTextVNode(" years of NI contributions. "))
            ]),
            _createElementVNode("p", null, [
              (_ctx.revisedStatePension == 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" Given this, we believe you may not receive a State Pension as you expect to have fewer than 10 years of contributions. ")
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _cache[32] || (_cache[32] = _createTextVNode(" Given this, as an estimate, we believe you may receive a revalued State Pension of ")),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.revisedStatePensionFormatted), 1),
                    _cache[33] || (_cache[33] = _createTextVNode(" from State Pension Age. "))
                  ], 64))
            ]),
            _createElementVNode("p", null, [
              _createElementVNode("a", _hoisted_17, _toDisplayString(_ctx.entitlementAdvice), 1)
            ]),
            (_ctx.hasQualifiedForPension)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _cache[34] || (_cache[34] = _createElementVNode("p", null, " The above is perfectly fine as an estimate, but if you want to refine this, the main further adjustment is that for many people, some of their previous NI years are in respect of \"contracted out NI years\" which can reduce the estimate a bit. ", -1)),
                    _createVNode(_component_options_question, {
                      name: "refineContractedOutQuestion",
                      question: "Do you want to consider contracted out years further?",
                      options: _ctx.yesNo,
                      selected: _ctx.refineContractedOutModel,
                      "onUpdate:selected": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.refineContractedOutModel) = $event)),
                      width: 25
                    }, null, 8, ["options", "selected"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("a", {
                  href: "",
                  class: "btn btn-outline-dark text-start me-3",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onInitialEstBackClick($event)))
                }, _cache[35] || (_cache[35] = [
                  _createElementVNode("i", { class: "bi bi-arrow-left" }, null, -1),
                  _createTextVNode(" Back ")
                ])),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onInitialEstNextClick && _ctx.onInitialEstNextClick(...args)))
                }, " Next ")
              ])
            ]),
            (_ctx.showInitialEstError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, _cache[36] || (_cache[36] = [
                  _createElementVNode("div", { class: "col" }, [
                    _createElementVNode("span", { class: "warn" }, "Please tell us if you are interested in considering contracted out years further.")
                  ], -1)
                ])))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showDefineCOPEEst)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _cache[40] || (_cache[40] = _createElementVNode("p", null, [
              _createTextVNode(" You need to get what is called a \"contracted out\" adjustment from "),
              _createElementVNode("a", {
                href: "https://www.gov.uk/check-state-pension",
                target: "_blank"
              }, "here"),
              _createTextVNode(". ")
            ], -1)),
            _cache[41] || (_cache[41] = _createElementVNode("p", null, [
              _createTextVNode(" Near the bottom of the page you may see the words \""),
              _createElementVNode("i", null, "You've been in a contracted-out pension scheme"),
              _createTextVNode("\". If not, there is no issue and you can ignore everything below. ")
            ], -1)),
            _cache[42] || (_cache[42] = _createElementVNode("p", null, " If so, click the link there and you will see. Your COPE estimate is £C a week on the page. ", -1)),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _cache[37] || (_cache[37] = _createElementVNode("span", { class: "me-2" }, "Enter this C figure here:", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.estCOPEModel) = $event)),
                  size: "3",
                  maxlength: "3",
                  onKeypress: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.checkNumeric && _ctx.checkNumeric(...args)))
                }, null, 544), [
                  [_vModelText, _ctx.estCOPEModel]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("a", {
                  href: "",
                  class: "btn btn-outline-dark text-start me-3",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onDefineCOPEEstBackClick($event)))
                }, _cache[38] || (_cache[38] = [
                  _createElementVNode("i", { class: "bi bi-arrow-left" }, null, -1),
                  _createTextVNode(" Back ")
                ])),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onDefineCOPEEstNextClick && _ctx.onDefineCOPEEstNextClick(...args)))
                }, " Next ")
              ])
            ]),
            (_ctx.showEstCopeError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, _cache[39] || (_cache[39] = [
                  _createElementVNode("div", { class: "col" }, [
                    _createElementVNode("span", { class: "warn" }, "Please enter the COPE estimate.")
                  ], -1)
                ])))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showUpdate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            (_ctx.isIncludingCopeEst)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("p", null, [
                    _cache[43] || (_cache[43] = _createTextVNode(" With this deduction, your revised estimated revalued State Pension from State Pension Age is now ")),
                    _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.revisedStatePensionWithCOPEFormatted), 1),
                    _cache[44] || (_cache[44] = _createTextVNode(" per year. "))
                  ]),
                  _cache[45] || (_cache[45] = _createElementVNode("p", null, " It may be the case that not all of this deduction will apply if you still accrue a full 35 years of NI contributions where no years were \"contracted out\", but if you want to be cautious you can add this full reduction. ", -1))
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("p", null, [
              _cache[46] || (_cache[46] = _createTextVNode(" Use the ")),
              _cache[47] || (_cache[47] = _createElementVNode("span", { class: "fst-italic" }, "Update my Plan", -1)),
              _createTextVNode(" button if you would like to update your State Pension information with the " + _toDisplayString(_ctx.updateEstimateText) + " or use the ", 1),
              _cache[48] || (_cache[48] = _createElementVNode("span", { class: "fst-italic" }, "Next", -1)),
              _cache[49] || (_cache[49] = _createTextVNode(" button if you would prefer to move on without updating. "))
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("a", {
                  href: "",
                  class: "btn btn-outline-dark text-start me-3",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onUpdateBackClick($event)))
                }, _cache[50] || (_cache[50] = [
                  _createElementVNode("i", { class: "bi bi-arrow-left" }, null, -1),
                  _createTextVNode(" Back ")
                ])),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary me-3",
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.onUpdateClick && _ctx.onUpdateClick(...args)))
                }, " Update my Plan "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.onUpdateNextClick && _ctx.onUpdateNextClick(...args)))
                }, " Next ")
              ])
            ]),
            (_ctx.showUpdateErrorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.updateErrorMessage), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showFinally)
      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              (_ctx.hasRefinedDetail)
                ? (_openBlock(), _createElementBlock("p", _hoisted_41, " Your plan has an estimated State Pension of " + _toDisplayString(_ctx.estimatedStatePension) + ". ", 1))
                : _createCommentVNode("", true),
              _cache[53] || (_cache[53] = _createElementVNode("p", null, " The State Pension changes each year depending on the future increases given and we will update this estimate each year automatically to allow for this. ", -1)),
              _cache[54] || (_cache[54] = _createElementVNode("p", null, " There are also a number of other issues which can affect your final State Pension to a lesser degree, but as you reach State Pension Age you can update the final figure if needed slightly once you know the exact amount. ", -1)),
              _cache[55] || (_cache[55] = _createElementVNode("p", null, [
                _createTextVNode(" If you need more help on the State Pension, or want to buy more NI contribution years "),
                _createElementVNode("a", {
                  href: "https://guiidewordpress.azurewebsites.net/dont-sleepwalk-into-a-low-state-pension/",
                  target: "_blank"
                }, "check out our blog post"),
                _createTextVNode(" which details everything you need to know. ")
              ], -1)),
              (_ctx.hasRefinedDetail)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _cache[51] || (_cache[51] = _createElementVNode("p", null, " Use the reset button if you would like to restore the default estimate or work through the refinement process again. ", -1)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary me-3",
                      onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.onUndoRefineClick && _ctx.onUndoRefineClick(...args)))
                    }, " Reset "),
                    (_ctx.showResetErrorMessage)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_42, [
                          _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.resetErrorMessage), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.showFinallyBackButton)
                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("a", {
                        href: "",
                        class: "btn btn-outline-dark text-start me-3",
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onFinallyBackClick($event)))
                      }, _cache[52] || (_cache[52] = [
                        _createElementVNode("i", { class: "bi bi-arrow-left" }, null, -1),
                        _createTextVNode(" Back ")
                      ]))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}